import type { IOTV_LCD_DeviceMessage, IOTV_LCD_MessageType, IOTV_LCD_RX_Data, MinimalBusinessObject } from './MessageTypes/IOTV_LCD_MessageType'

import type { ValidBusinessObject } from '../datastoreProxy'
import { MapLike } from '../core'

import { DisplayedDeviceIOTMetadata } from '../IoTCore'
import { DeviceTypes } from './DeviceTypes'
import { Networks } from './NetworkTypes'
import { Position } from '../Geo'

export type metadata = {
  deviceId: string
  deviceName?: string
  messageId?: string
  timestamp?: number
  systemStage?: string
  accountId?: string
  projectCode?: string
  customerDeviceId?: string
  deviceEui?: string
  deviceType?: DeviceTypes
  networkKey?: Networks
  nasSourceIp?: string
  applicationId?: string
  resolvedDevice?: MinimalBusinessObject & { eui: string; networkKey: string; appID: string }
  resolvedCustomer?: MinimalBusinessObject
  resolvedGroup?: MinimalBusinessObject
  resolvedProperty?: MinimalBusinessObject
} & DeviceNWAttributes

export type DeviceRecordType = {
  app_id: string
  dev_id: string
  hardware_serial: string
  lastSeen: number
  name: string
  thingTypeName: string
  billingGroupName: string
  groups?: string
} & ValidBusinessObject

export type GatewayRecordType = {
  lastSeen: number
  gtw_id: any
  gtw_trusted: any
  location: Position
  location_source: any
} & ValidBusinessObject

export type DisplayableLCDMessageType = Partial<IOTV_LCD_MessageType> & ValidBusinessObject

export type DisplayableLCDMessageTypePlusIot = DisplayableLCDMessageType & Partial<DisplayedDeviceIOTMetadata>

/**
 * Attributes from device message decoding to be included in nw device message
 */
export type NWMonitoringPayloadAttributes = {
  position?: Position
  battery?: number
  batteryCharging?: boolean
  reboot?: boolean
  downlinkAck?: boolean
  batteryErr?: boolean
  linkCheckErr?: boolean
}

/**
 * Attributes from network Message to be included in decdded device message meta atts and added to Device
 */
export type DeviceNWAttributes = Partial<
  Pick<IOTV_LCD_DeviceMessage, 'fCnt' | 'adr' | 'bw' | 'dr' | 'frequency' | 'sf'> & Pick<IOTV_LCD_RX_Data, 'rssi' | 'snr' | 'gatewayEui' | 'channel'>
>

export enum MessageAction {
  ACK = 'ACK',
  DOWNLINK = 'DOWNLINK', // prsumably this is for out going downlinks
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  ERROR = 'ERROR',
  JOIN = 'JOIN',
  STATUS = 'STATUS',
  TXACK = 'TXACK', // on chirpstack this may correspond to queued or perhaps sent, not clear from docs, looks like SENT
  UPLINK = 'UPLINK',
  WTF = 'WTF',
}

export enum GatewayStatus {
  COMMISSIONED = 'C',
  DECOMMISSIONED = 'D',
  NOT_COMMISSIONED = 'N',
}

export enum DeviceStatus {
  COMMISSIONED = 'C',
  DECOMMISSIONED = 'D',
  NOT_COMMISSIONED = 'N',
}
